import React from "react";

import { SatisfactionScores } from "../../api";
import StatisticBox from "../../common/components/StatisticBox";

interface AttendeeScoresProps {
  data: SatisfactionScores | undefined;
  isAverage?: boolean;
}

const AttendeeScores = ({ data, isAverage }: AttendeeScoresProps) => {
  return (
    <StatisticBox
      {...{
        title: "Satisfaction Scores",
        value: data ? data.overall : "-",
        isPercent: true,
        description: isAverage ? "average" : "",
        results: [
          {
            title: isAverage ? "AVG. Content" : "Content",
            value: data ? data.content : "-",
            isPercent: true,
          },
          {
            title: isAverage ? "AVG. Presenter" : "Presenter",
            value: data ? data.presenter : "-",
            isPercent: true,
          },
        ],
      }}
    />
  );
};

export default AttendeeScores;
